import { clsx, type ClassValue } from 'clsx';

/**
 * Utility function to merge class names with clsx
 * This is a common pattern in modern React applications for conditional class names
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
